






















import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    type: { type: String, default: 'default', validator: (v: string) => ['default', 'inverted'].includes(v) },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    products: { type: Array, default: () => [] },
  },
});
